import { ButtonCusWithIcon } from '@/components/common/Button';
import { useStore } from '@/hooks/useStore';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import ChangePasswordCmsForm from './ChangePasswordCmsForm';
import { useParams } from 'react-router-dom';
import { flowResult } from 'mobx';

export default observer(function PasswordAction() {
    // hook
    const { t } = useTranslation();
    const { id } = useParams();

    // store
    const {
        authStore: { resetPasswordCMS },
        modalStore: { showAlertModal, hideModal },
        accountStore: { getHisoryChangeUser, defaultPagingHistory }
    } = useStore();

    // function
    // handle change password
    const onClickBtnChangePassword = () => {
        showAlertModal({
            id: 'change-password-cms-modal',
            title: t('words_title.change_password'),
            size: 'xl',
            titleClassName: 'text-center max-w-none',
            content: (
                <ChangePasswordCmsForm idModal='change-password-cms-modal' />
            ),
            footerClassName: 'hidden'
        });
    };

    // handle reset password
    const onClickBtnResetPassword = () => {
        showAlertModal({
            id: 'reset-password-cms-confirm',
            isConfirmModal: true,
            content: t('sentences.confirm_reset_password'),
            saveButton: t('button.reset'),
            onSave: () => {
                onResetPassword(Number(id));
                hideModal('reset-password-cms-confirm');
            }
        });
    };

    const onResetPassword = async (id: number) => {
        const res = await flowResult(resetPasswordCMS(id));
        if (res) {
            showAlertModal({
                id: 'reset-password-success',
                type: 'success',
                content: t('messages.reset_password_success'),
                onClickXIcon: () => onFetchHistory(Number(id), defaultPagingHistory)
            });
        }
    };

    const onFetchHistory = async (userId: number, paging: any) => {
        await flowResult(getHisoryChangeUser({ userId }, paging));
    };

    return (
        <div className='md:flex md:items-start'>
            <div className='flex gap-2 sm:gap-6'>
                <ButtonCusWithIcon
                    type='button'
                    size='default'
                    variant='outline'
                    className='w-[184px] gap-1.5 whitespace-nowrap px-2 h-10'
                    onClick={onClickBtnChangePassword}
                    iconId='#icon-change-password'
                    widthIcon={16}
                    heightIcon={22}
                >
                    {t('words_title.change_password')}
                </ButtonCusWithIcon>
                <ButtonCusWithIcon
                    type='button'
                    size='default'
                    variant='default'
                    className='w-[184px] gap-1.5 whitespace-nowrap px-2 h-10'
                    onClick={onClickBtnResetPassword}
                    iconId='#icon-reset-password'
                    widthIcon={29}
                    heightIcon={22}
                >
                    {t('button.reset_password')}
                </ButtonCusWithIcon>
            </div>
        </div>
    );
});
